angular.module('lsnBase.deprecated.models')
  .factory('DistributionChannelModel', ['LsnDistributionChannelModelV1',
    function(LsnDistributionChannelModelV1) {
      return LsnDistributionChannelModelV1;
    }
  ]);